import styled from "styled-components";
import { ReactComponent as BuildingShield } from "../../../../assets/images/svg/building-shield.svg";

export const BuildingShieldIcon = styled(BuildingShield)`

`